export default __webpack_public_path__ + "static/media/XEMP-16.3c2d6859.jpg";